import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";

export const Screen = ({ children, className = "" }) => (
  <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }} className={`px-6 pt-[max(env(safe-area-inset-top),2rem)] ${className}`}>
    {children}
  </motion.div>
);

export const PageHeader = ({ title, overline, back = false, right = null }) => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        {back && (
          <button onClick={() => navigate(-1)} data-testid="back-button" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center active:scale-90 transition-transform">
            <ChevronLeft size={20} />
          </button>
        )}
        <div>
          {overline && <p className="text-[#D4AF37] text-[11px] uppercase tracking-[0.25em]">{overline}</p>}
          <h1 className="font-display text-3xl font-bold tracking-tight">{title}</h1>
        </div>
      </div>
      {right}
    </div>
  );
};

export const Card = ({ children, className = "", ...props }) => (
  <div {...props} className={`rounded-3xl bg-white/5 backdrop-blur-lg border border-white/10 p-6 ${className}`}>
    {children}
  </div>
);

export const Empty = ({ icon: Icon, text }) => (
  <div className="rounded-3xl bg-white/5 border border-white/10 p-10 text-center">
    {Icon && <Icon className="mx-auto text-[#A19DB0] mb-3" strokeWidth={1.5} />}
    <p className="text-[#A19DB0] text-sm">{text}</p>
  </div>
);
